import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { IState } from "./types";

// --------------------------------------------

export const initialState: IState = {
  role: undefined,
  isApiRequestLoading: false,
};

const slice = createSlice({
  name: "common",
  initialState,
  reducers: {
    setRole(state, action: PayloadAction<string>) {
      state.role = action.payload;
    },
    setLogin(state, action: PayloadAction<any>) {
      state.login = action.payload;
    },
    logout(state) {
      Object.entries(initialState).forEach(([key, value]) => {
        (state as any)[key] = value;
      });
      state.login = null;
      state.role = undefined;
    },
    setIsAPiRequestLoading(state, action) {
      state.isApiRequestLoading = action.payload;
    },
  },
});

export default slice.reducer;

export const commonSlice = slice.reducer;

export const { setRole, setLogin, logout, setIsAPiRequestLoading } =
  slice.actions;
